import * as React from 'react';
import { observer, Provider } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observable } from 'mobx';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Route, Switch } from 'react-router';
import { V3Routes } from '../../routes';
import { ApplicationPageSummaryPane } from '../../components/organisms/application/ApplicationPageSummaryPane';
import { ApplicationPageUserInfoPane } from '../../components/organisms/application/ApplicationPageUserInfoPane';
import { ApplicationPageUserSignInPane } from '../../components/organisms/application/ApplicationPageUserSignInPane';
import { ApplicationPageUserSummaryPane } from '../../components/organisms/application/ApplicationPageUserSummaryPane';
import { ApplicationPagePaymentInfoPane } from '../../components/organisms/application/ApplicationPagePaymentInfoPane';
import { ApplicationPageConfirmationPane } from '../../components/organisms/application/ApplicationPageConfirmationPane';
import { ApplicationPageCompletePaneForBeauty } from '../../components/organisms/application/ApplicationPageCompletePane';
import { BeautyApplicationPageState } from './states/BeautyApplicationPageState';
import { BeautyStartDateSelectionPane } from '../../components/organisms/application/BeautyStartDateSelectionPane';
import { ApplicationPageUserAddressPane } from '../../components/organisms/application/ApplicationPageUserAddressPane';
import { ApplicationPageContext, ApplicationPageHeaderType } from '../../contexts/applicaitonPageContext';

@withNavigation(NavigationSpecs.none())
@observer
export class BeautyApplicationPage extends React.Component {
    @observable pageState = new BeautyApplicationPageState(GlobalStatesV3.currentUser, GlobalStatesV3.routing);

    componentDidMount() {
        this.pageState.init();
    }

    render() {
        return (
            <Provider applicationState={this.pageState}>
                <ApplicationPageContext.Provider value={{ headerType: ApplicationPageHeaderType.TEXT }}>
                    <Switch>
                        <Route
                            exact
                            path={V3Routes.beautyApplicationSignIn().stringify()}
                            component={ApplicationPageUserSignInPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationUserInfo().stringify()}
                            component={(props) => (
                                <ApplicationPageUserInfoPane {...props} nextButtonLabel={'住所情報の入力へ'} />
                            )}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationUserSummary().stringify()}
                            component={(props) => (
                                <ApplicationPageUserSummaryPane {...props} nextButtonLabel={'住所情報の入力へ'} />
                            )}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationAddressInfo().stringify()}
                            component={ApplicationPageUserAddressPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationStartDateSelect().stringify()}
                            component={BeautyStartDateSelectionPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationSummary().stringify()}
                            component={ApplicationPageSummaryPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationPaymentMethod().stringify()}
                            component={ApplicationPagePaymentInfoPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationConfirmation().stringify()}
                            component={ApplicationPageConfirmationPane}
                        />
                        <Route
                            exact
                            path={V3Routes.beautyApplicationComplete().stringify()}
                            component={ApplicationPageCompletePaneForBeauty}
                        />
                    </Switch>
                </ApplicationPageContext.Provider>
            </Provider>
        );
    }
}
